import './DeadlineNote.css'

/**
 * The amber sticky-note deadline callout — the one playful motif in the brand.
 * `tilt` is a static rotation (−2°…2°), not motion, so it is kept under
 * prefers-reduced-motion.
 */
export function DeadlineNote({ date, children, tilt = -2, style }) {
  return (
    <div
      className="u-note"
      style={{ transform: 'rotate(' + tilt + 'deg)', ...style }}
    >
      <div className="u-note-date">
        <span className="u-note-dot" aria-hidden="true" />
        {date}
      </div>
      {children && <div className="u-note-label">{children}</div>}
    </div>
  )
}

export default DeadlineNote
